__webpack_require__.p = "https://bmidxbdenmarkplprod.netlify.app/";